import React from 'react';
import styled from '@emotion/styled';
import { Link } from 'react-router-dom';
import { Spinner } from './Loader';

export const ButtonLinkStyled = styled(Link)`
  background: ${(props) => props.theme.buttonBackgroundColor};
  border-radius: 5px;
  width: 100%;
  height: 44px;
  font-size: 16px;
  color: ${(props) => props.theme.buttonTextColor};

  margin-top: 50px;
  margin-bottom: 50px;

  display: flex;
  justify-content: center;
  align-items: center;
  text-decoration: none;

  &:hover,
  &:focus,
  &:active {
    text-decoration: none;
    color: ${(props) => props.theme.buttonTextColor};
  }
`;

export const ButtonLink = ({ disabled, text, ...props }) => {
  return (
    <ButtonLinkStyled disabled={disabled} {...props}>
      {disabled ? <Spinner testId="button-link-spinner" /> : text}
    </ButtonLinkStyled>
  );
};
